import { Component } from '@verndale/core';
import HamburgerMenu from './hamburgerMenu';
import MegaMenu from './megaMenu';
import MegaMenuIntegratedTabs from './megaMenuIntegratedTabs';
import HeaderSearch from './search';
import LanguageMenu from './languageMenu';
import StickyNavigation from './stickyNavigation'

class Module extends Component {
  setupDefaults() {
    this.dom = {
      pageContainer: document.querySelector('.page-container'),
      hamburgerMenuToggle: [...this.el.querySelectorAll(
        '.hamburger-menu__primary-link'
      )],
      hamburgerMenu: this.el.querySelector('.hamburger-menu__submenu'),
      hamburgerMenuToggleSmDevice: this.el.querySelector('.header__hamburger-menu-toggle'),
      hamburgerMenuSmDevice: this.el.querySelector('.hamburger-menu__sm-device'),
      languageMenuToggle: this.el.querySelector('.header__language-toggle'),
      languageMenu: this.el.querySelector('.language-menu'),
      searchToggle: this.el.querySelector('.header__search-toggle'),
      headerSearch: this.el.querySelector('.header-search'),
      stickySubNav: this.el.querySelector('.header__sticky-hidden'),
      megaMenu: this.el.querySelector('.mega-menu__submenu'),
      megaMenuIntegratedTabs: this.el.querySelectorAll('.mega-menu-integrated-tab'),
      megaMenuSmDevice: this.el.querySelector('.mega-menu__sm-device')
    };

    if (this.dom.hamburgerMenu) {
      this.hamburgerMenu = new HamburgerMenu(this.el);
    }

    if (this.dom.megaMenu) {
      this.megaMenu = new MegaMenu(this.el);
      this.dom.megaMenuIntegratedTabs.forEach(tab => {
        this.megaMenuIntegratedTabs = new MegaMenuIntegratedTabs(tab);
      });
    }

    if (this.dom.headerSearch) {
      this.headerSearch = new HeaderSearch(this.el);
    }

    if (this.dom.languageMenu) {
      this.languageMenu = new LanguageMenu(this.el);
    }

    new StickyNavigation(this.el);

    this.handleScroll();
  }

  addListeners() {
    document.addEventListener('scroll', this.handleScroll.bind(this));
    window.addEventListener('resize', this.handleScroll.bind(this));

    if (this.dom.searchToggle) this.dom.searchToggle.addEventListener('click', this.toggleSearch.bind(this));

    this.dom.languageMenuToggle.addEventListener('click', this.toggleLanguageMenu.bind(this));

    this.dom.hamburgerMenuToggle.forEach(button => {
      button.addEventListener('click', this.toggleHamburgerMenu.bind(this));
    });

    this.dom.hamburgerMenuToggleSmDevice.addEventListener('click', this.toggleHamburgerMenuSmDevice.bind(this));

  }

  toggleSearch(e) {
    if (this.languageMenu) {
      this.languageMenu.closeDrawer(e);
    }

    if (this.hamburgerMenu) {
      this.hamburgerMenu.hideSubmenus(e);
      this.hamburgerMenu.closeDrawer(e);
    }

    if (this.megaMenu) {
      this.megaMenu.hideSubmenus(e);
      this.megaMenu.closeDrawer(e);
    }

    this.headerSearch.toggleDrawer(e);
  }

  toggleLanguageMenu(e) {
    if (this.headerSearch) {
      this.headerSearch.closeDrawer(e);
    }

    if (this.hamburgerMenu) {
      this.hamburgerMenu.hideSubmenus(e);
      this.hamburgerMenu.closeDrawer(e);
    }

    if (this.megaMenu) {
      this.megaMenu.hideSubmenus(e);
      this.megaMenu.closeDrawer(e);
    }

    this.languageMenu.toggleDrawer(e);
  }

  toggleHamburgerMenu(e) {
    if (this.languageMenu) {
      this.languageMenu.closeDrawer(e);
    }

    if (this.headerSearch) {
      this.headerSearch.closeDrawer(e);
    }
  }

  toggleHamburgerMenuSmDevice(e) {
    if (this.languageMenu) {
      this.languageMenu.closeDrawer(e);
    }

    if (this.headerSearch) {
      this.headerSearch.closeDrawer(e);
    }

    if (this.hamburgerMenu) {
      this.hamburgerMenu.toggleDrawer(e);
    } else {
      this.megaMenu.toggleDrawer(e);
    }
  }

  handleScroll() {
    const hero = document.querySelector('[data-hero="true"]');
    const { offsetHeight, offsetTop } = hero;
    const headerHeight = this.el.offsetHeight;
    const scroll = window.scrollY;
    const pageContentScroll = scroll - offsetTop;

    if (pageContentScroll >= headerHeight) {
      this.el.classList.add('scrolled');
    } else {
      this.el.classList.remove('scrolled');
    }

    if (pageContentScroll >= offsetHeight - headerHeight) {
      this.dom.stickySubNav.classList.add('show');
    } else {
      this.dom.stickySubNav.classList.remove('show');
    }
  }
}

export default Module;
